import { Container } from '@/atoms/Container/Container';
import { Skeleton } from '@/atoms/Skeleton/Skeleton';

interface ResourceCardSkeletonProps {
  /** Also hold the place of the bottom zone (action row and tags; a card in a post); not while composing. */
  withActions?: boolean;
}

/**
 * Loading state of `ResourceCard`, in its frame: type and source on top, image and title beside
 * it, then the bottom zone (tag label and actions, then the tags) under one divider.
 */
export function ResourceCardSkeleton({ withActions = false }: ResourceCardSkeletonProps) {
  return (
    <Container
      overrideDefaults
      data-testid="resource-card-skeleton"
      className="flex w-full min-w-0 flex-col divide-y divide-card overflow-hidden rounded-md bg-muted"
    >
      <Container overrideDefaults className="flex flex-col gap-3 p-4">
        <Container overrideDefaults className="flex items-center justify-between gap-3">
          <Skeleton className="h-4 w-20 rounded-md" />
          <Skeleton className="h-4 w-24 rounded-md" />
        </Container>
        <Container overrideDefaults className="flex gap-4">
          <Skeleton className="size-20 shrink-0 rounded-md sm:size-24" />
          <Container className="min-w-0 flex-1 gap-2">
            <Skeleton className="h-5 w-48 max-w-full rounded-md" />
            <Skeleton className="h-4 w-full rounded-md" />
            <Skeleton className="h-4 w-32 rounded-md" />
          </Container>
        </Container>
      </Container>
      {withActions && (
        <Container
          overrideDefaults
          data-testid="resource-card-skeleton-actions"
          className="flex flex-col gap-2 px-4 py-3"
        >
          <Container overrideDefaults className="flex items-center justify-between gap-3">
            <Skeleton className="h-3 w-32 rounded-md" />
            <Container overrideDefaults className="flex gap-2">
              <Skeleton className="h-8 w-10 rounded-md" />
              <Skeleton className="h-8 w-10 rounded-md" />
              <Skeleton className="h-8 w-10 rounded-md" />
            </Container>
          </Container>
          <Skeleton className="size-8 rounded-md" />
        </Container>
      )}
    </Container>
  );
}
